/**
 * Sweetums pack pricing — matches Shopify cart discounts.
 *
 * One-time pack discounts (automatic discounts, allocation_method: each):
 *   3 = 10%, 5 = 15%, 7 = 20%
 *   → floor(unit × pct / 100) off each unit, then × qty
 *
 * Subscribe:
 *   1. Use the real selling-plan allocation unit (per product; may be 15%, 18%, etc.)
 *      Fallback: round(retail × 0.85) when no allocation is provided
 *   2. Same pack % discounts applied to that unit (stacks with SAVE10%/SAVE15%)
 *
 * Rose Wipes $10.99 → plan unit $8.99 → 5 Pack Subscribe = $38.25 in cart
 * Strawberry $16.99 → plan unit $14.44 → 5 Pack Subscribe = $61.40 in cart
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.SweetumsPackPricing = factory();
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var PACK_PERCENTS = { 3: 10, 5: 15, 7: 20 };

  function getPackFullPrice(unitCents, qtyNum) {
    return (Number(unitCents) || 0) * (Number(qtyNum) || 1);
  }

  /** Shopify % discount with allocation_method: "each" */
  function percentOffEach(unitCents, qtyNum, percent) {
    var unit = Number(unitCents) || 0;
    var qty = Number(qtyNum) || 1;
    var discountPerUnit = Math.floor((unit * percent) / 100);
    return (unit - discountPerUnit) * qty;
  }

  function getOneTimePackPrice(unitCents, qtyNum) {
    var qty = Number(qtyNum) || 1;
    var percent = PACK_PERCENTS[qty];
    if (percent == null) return (Number(unitCents) || 0) * qty;
    return percentOffEach(unitCents, qty, percent);
  }

  /**
   * @param {number} unitCents retail unit
   * @param {number|null|undefined} allocationUnitCents selling-plan unit from Shopify
   */
  function getSubscriptionUnitPrice(unitCents, allocationUnitCents) {
    var allocated = Number(allocationUnitCents);
    if (allocated > 0) return allocated;
    return Math.round((Number(unitCents) || 0) * 0.85);
  }

  function getSubscriptionPackPrice(unitCents, qtyNum, allocationUnitCents) {
    return getOneTimePackPrice(
      getSubscriptionUnitPrice(unitCents, allocationUnitCents),
      qtyNum
    );
  }

  /** Read unit price from [data-csw-json] variant.allocations */
  function getAllocationUnitPrice(variant, planId) {
    if (!variant || !variant.allocations) return null;
    var allocations = variant.allocations;
    if (planId != null && planId !== '') {
      if (allocations[planId] && allocations[planId].price > 0) {
        return Number(allocations[planId].price);
      }
      if (allocations[String(planId)] && allocations[String(planId)].price > 0) {
        return Number(allocations[String(planId)].price);
      }
      var matched = Object.keys(allocations)
        .map(function (key) {
          return allocations[key];
        })
        .find(function (item) {
          return item && String(item.sellingPlanId) === String(planId);
        });
      if (matched && matched.price > 0) return Number(matched.price);
    }
    var first = Object.keys(allocations)
      .map(function (key) {
        return allocations[key];
      })
      .find(function (item) {
        return item && item.price > 0;
      });
    return first ? Number(first.price) : null;
  }

  function resolvePlanId() {
    if (typeof document === 'undefined') return '';
    var frequencySelect =
      document.querySelector(
        '[data-csw-group]:has([data-csw-group-radio]:checked) .csw-frequency-select'
      ) || document.querySelector('.csw-frequency-select');
    if (frequencySelect && frequencySelect.value) return String(frequencySelect.value);

    var group =
      document.querySelector('[data-csw-group-radio]:checked')?.closest('[data-csw-group]') ||
      document.querySelector('[data-csw-group][data-default-plan-id]');
    if (group?.dataset?.defaultPlanId) return String(group.dataset.defaultPlanId);

    var jsonEl = document.querySelector('[data-csw-json]');
    if (jsonEl) {
      try {
        return String(JSON.parse(jsonEl.textContent).defaultPlanId || '');
      } catch (e) {
        return '';
      }
    }
    return '';
  }

  return {
    PACK_PERCENTS: PACK_PERCENTS,
    getPackFullPrice: getPackFullPrice,
    percentOffEach: percentOffEach,
    getOneTimePackPrice: getOneTimePackPrice,
    getSubscriptionUnitPrice: getSubscriptionUnitPrice,
    getSubscriptionPackPrice: getSubscriptionPackPrice,
    getAllocationUnitPrice: getAllocationUnitPrice,
    resolvePlanId: resolvePlanId,
  };
});
